(function(global) {
    'use strict';
    
    var cjs = global.createjs || {};
    
    // extend2
    cjs.extend2 = function(superclass, subclass, prototype) {
        function Proto2() { 
            this.constructor = subclass;
            this.__parent__ = superclass;
        }
        Proto2.prototype = new (superclass)();
        _.extend(Proto2.prototype, subclass.prototype, prototype);
        
        function Extend2() {
            subclass.apply(this, arguments);
        }
        Extend2.prototype = new Proto2();
        return Extend2;
    };

    // patch Point prototype
    _.extend(cjs.Point.prototype, {
        distance: function(p2) {
            var dx = (p2.x-this.x),
                dy = (p2.y-this.y);
            return Math.sqrt(dx*dx + dy*dy);
        },
        midPoint: function(p2) {
            return new cjs.Point((this.x + p2.x)/2, (this.y+ p2.y)/2);
        }
    });
    
    // patch MouseEvent prototype
    _.extend(cjs.MouseEvent.prototype, {
        toPoint: function() {
            return new cjs.Point(this.stageX, this.stageY);
        }
    });

    // swipe & pinch events mixin
    cjs.TouchMixin = {
        touches1: {},
        touches2: {},
        swipeThreshold: 100,
        pinchThreshold: 150,
        initTouch: function() {
            this.on("mousedown", this._touchMousedown, this);
            this.on("pressup", this._touchPressup, this);
            this.on("pressmove", this._touchPressmove, this);
        },
        _touchMousedown: function(evt) {
            this.touches1[evt.pointerID] = evt;
        },
        _touchPressup: function(evt) {
            delete this.touches1[evt.pointerID];
            delete this.touches2[evt.pointerID];
        },
        _touchPressmove: function(evt) {
            this.touches2[evt.pointerID] = evt;
            this.onTouch(_.values(this.touches1), _.values(this.touches2));
        },
        onTouch: function(touch1, touch2) {
            if (touch2.length === 1) {
                var dx = (touch2[0].stageX - touch1[0].stageX),
                    dy = (touch2[0].stageY - touch1[0].stageY),
                    thresh = this.getSwipeThreshold();
                if (Math.abs(dy) > thresh && Math.abs(dx) < thresh/2) {
                    if (dy > 0) {
                        this.onSwipeDown(touch1, touch2);
                    }
                    else {
                        this.onSwipeUp(touch1, touch2);
                    }
                }
                else if (Math.abs(dx) > thresh && Math.abs(dy) < thresh/2) {
                    if (dx > 0) {
                        this.onSwipeRight(touch1, touch2);
                    }
                    else {
                        this.onSwipeLeft(touch1, touch2);
                    }
                }
            }
            else if (touch2.length === 2) {
                var startDist = touch1[0].toPoint().distance(touch1[1].toPoint()),
                    currDist = touch2[0].toPoint().distance(touch2[1].toPoint()),
                    distance = currDist - startDist;
                if (distance > this.getPinchThreshold()) {
                    this.onPinchIn(touch1, touch2);
                }
                else if (distance < -this.getPinchThreshold()) {
                    this.onPinchOut(touch1, touch2);
                }
            }
        },
        getSwipeThreshold: function() {
            return this.stage.canvas.height/window.innerHeight*this.swipeThreshold;
        },
        onSwipeDown: function(touch1, touch2) {
            
        },
        onSwipeUp: function(touch1, touch2) {

        },
        onSwipeRight: function(touch1, touch2) {

        },
        onSwipeLeft: function(touch1, touch2) {

        },
        getPinchThreshold: function() {
            return this.stage.canvas.height/global.innerHeight*this.pinchThreshold;
        },
        onPinchIn: function(touch1, touch2) {
            
        },
        onPinchOut: function(touch1, touch2) {

        }
    };

})(this);
